export default (state) => state.importers.data
